export interface IInputVoting {
  plate_uuid: string;
  competitors: number[]; // enviar apenas os IDs validos os votos brancos serão ajustados no backend
}

export interface IVoting {
  receipt: string;
}

export interface IElectionConfigs {
  whatsapp: string;
  input_login: string;
  input_password: string;
  force_reset_password: boolean;
  enable_single_vote: boolean;
  enable_auto_logout: boolean;
  i18n_enable: boolean;
  i18n_locales: string[];
  show_receipt_view: boolean;
  enable_auto_advance: boolean;
  enable_receipt_consult: boolean;
  send_receipt_enable: boolean;
  enable_early_access: boolean;
  message_early_access?: string;
}

export interface IElection {
  id: number;
  name: string;
  description: string;
  status: string;
  _status: string;
  host: string;
  help: string;
  _thumb_src: string;
  configs: IElectionConfigs;
  _opt_in?: {
    file_src: string;
    label: string;
  };
}

export interface IPlate {
  id: number;
  uuid: string;
  name: string;
  description: string;
  configs: IPlateConfigs;
  status: PlateVoteStatusEnum;
}

export interface IPlateConfigs {
  choice_min: number;
  choice_max: number;
}

export enum PlateVoteStatusEnum {
  OPEN = 'open',
  VOTED = 'voted',
  UNDO = 'undo',
}

export interface IParty {
  id: number;
  name: string;
  thumb_src?: string;
}

export interface IPlateData {
  id: number;
  uuid: string;
  name: string;
  description: string;
  qt_competitors: number;
  configs: IPlateConfigs;
  status: string;
}

export interface IRound {
  laps: number;
  description: string;
}

export interface ICompetitor {
  id: number;
  name: string;
  description?: any;
  thumb?: any;
}

export interface IPlateDetail {
  plate: IPlateData;
  round: IRound;
  competitors: ICompetitor[];
}



// WEBPACK FOOTER //
// ./src/features/election/store/types.ts